import {Component, OnInit} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {DateRangeSelectorComponent} from '../../../layout/date-range-selector/date-range-selector.component';
import {DatePipe, NgForOf} from '@angular/common';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {DateRange} from '../../../../types/date-range';
import {Offer} from '../../../../models/offer';
import {OfferService} from '../../../../services/offer/offer.service';
import {ApiClientService} from '../../../../services/api-client/api-client.service';
import {StatisticService} from '../../../../services/statistic/statistic.service';

@Component({
  selector: 'app-report-tab',
  imports: [
      RouterOutlet,
      RouterLink,
      RouterLinkActive,
      DateRangeSelectorComponent,
      NgForOf,
      ReactiveFormsModule
  ],
  providers: [DatePipe],
  templateUrl: './report-tab.component.html',
  styleUrl: './report-tab.component.scss'
})
export class ReportTabComponent implements OnInit {

  offers: Offer[] = [];
  dateRangeInvalid: boolean = false;
  filters: FormGroup = new FormGroup({
    startDate: new FormControl(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)),
    endDate: new FormControl(new Date(new Date().getFullYear(), new Date().getMonth(), 0)),
    offerId: new FormControl(''),
    subid: new FormControl(''),
    tc1: new FormControl(''),
    tc2: new FormControl(''),
    tc3: new FormControl(''),
    tc4: new FormControl(''),
  });

  constructor(
    private offerService: OfferService,
    private statisticService: StatisticService,
    private apiClient: ApiClientService,
    private datePipe: DatePipe
  ) {
  }

  ngOnInit(): void {
    this.offerService.findAll({sort: 'name'}).subscribe((offers: Offer[]) => {
      this.offers = offers;

      this.onSubmit();
    });
  }

  onSubmit(): void {
    const filters: any = this.filters.value;
    filters.startDate = this.datePipe.transform(this.filters.value.startDate, 'yyyy-MM-dd');
    filters.endDate = this.datePipe.transform(this.filters.value.endDate, 'yyyy-MM-dd');

    for (const [key, value] of Object.entries(filters)) {
      if (value === '') {
        delete filters[key];
      }
    }

    this.statisticService.$filters.next(filters);
  }

  updateRange(dateRange: DateRange): void {
    this.filters.get('startDate')?.patchValue(dateRange.start);
    this.filters.get('endDate')?.patchValue(dateRange.end);
  }
}
